package one.healthium.domain.paywall.models


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.PlatformValueSerializer

@Serializable
data class ProductDefaults(
    @SerialName("highlighted_product") @Serializable(with = PlatformValueSerializer::class) val highlightedProduct: String?,
    @SerialName("periods") val periodsMapping: Map<String, String>,
    @SerialName("period_nums") val periodNumsMapping: Map<String, String>,
)
